import React, { useState, useEffect, useRef } from 'react';
import { Typography, Container, Paper, Box, InputAdornment } from '@mui/material';
import {
  obtenerNotasDelDiaUsuarioEnv,
  obtenerNotasPorFechaEnv,
} from '../../actions/NotasAction';
import SendIcon from '@mui/icons-material/Send';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import GetAppIcon from '@mui/icons-material/GetApp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from 'date-fns/locale/es';
import {
  LocalizationProvider ,
  DatePicker,
} from '@mui/x-date-pickers';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import { obtenerUsuarioConImagen } from '../../actions/UsuariosAction';
import { useStateValue } from '../../contexto/store';
import { downloadFile } from '../../actions/ArchivosAction';
import { obtenerDatosUsuario } from '../../actions/UsuariosAction';

const NotasEnviadas = () => {
  const [lista, setLista] = useState([]);
  const [{ sesionUsuario }] = useStateValue();
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const mounted = useRef(true);
  const handleDateChange = (date) => {
    setSelectedDate(date);
    setLista([]);
    let fecha =
      date.getFullYear() +
      '-' +
      (date.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      date.getDate().toString().padStart(2, '0') +
      'T' +
      date.getHours().toString().padStart(2, '0') +
      ':' +
      date.getMinutes().toString().padStart(2, '0') +
      ':00';
    setLista([]);
    obtenerNotasPorFechaEnv(fecha, sesionUsuario.usuario.userName).then(
      (response) => {
        if (response.status === 200) {
          response.data.map((data) => {
            if (
              data.archivoUrl === 'undefined' ||
              data.archivoUrl === undefined ||
              data.archivoUrl === null
            ) {
              obtenerUsuarioConImagen(data.remitenteUserName).then(
                (response) => {
                  obtenerDatosUsuario(data.destinatarioUserName).then(
                    (response2) => {
                      setLista((anterior) => [
                        ...anterior,
                        {
                          Texto: data.texto,
                          UserName: response.data.userName,
                          Token: response.data.token,
                          Email: response.data.email,
                          NOMBRECOMPLETO: response.data.nombrecompleto,
                          imagenPerfil: response.data.imagenPerfil,
                          Fecha: data.fecgra,
                          Difusion: data.difusion,
                          Id: data.notA_Id,
                          Leido: data.leido,
                          destinatario: response2.data.nombrecompleto,
                        },
                      ]);
                    }
                  );
                }
              );
            } else {
              obtenerUsuarioConImagen(data.remitenteUserName).then(
                (response) => {
                  obtenerDatosUsuario(data.destinatarioUserName).then(
                    (response2) => {
                      setLista((anterior) => [
                        ...anterior,
                        {
                          Archivo: data.archivoUrl,
                          Texto: data.texto,
                          UserName: response.data.userName,
                          Token: response.data.token,
                          Email: response.data.email,
                          NOMBRECOMPLETO: response.data.nombrecompleto,
                          imagenPerfil: response.data.imagenPerfil,
                          Fecha: data.fecgra,
                          Difusion: data.difusion,
                          Id: data.notA_Id,
                          Leido: data.leido,
                          destinatario: response2.data.nombrecompleto,
                        },
                      ]);
                    }
                  );
                }
              );
            }
            return lista;
          });
        }
      }
    );
  };
  const descargarArchivo = (url) => {
    downloadFile(url);
  };
  useEffect(() => {
    if (mounted.current) {
      obtenerNotasDelDiaUsuarioEnv(sesionUsuario.usuario.userName).then(
        (response) => {
          if (response.status === 200) {
            response.data.map((data) => {
              if (
                data.archivoUrl === 'undefined' ||
                data.archivoUrl === undefined ||
                data.archivoUrl === null
              ) {
                obtenerUsuarioConImagen(data.remitenteUserName).then(
                  (response) => {
                    obtenerDatosUsuario(data.destinatarioUserName).then(
                      (response2) => {
                        setLista((anterior) => [
                          ...anterior,
                          {
                            Texto: data.texto,
                            UserName: response.data.userName,
                            Token: response.data.token,
                            Email: response.data.email,
                            NOMBRECOMPLETO: response.data.nombrecompleto,
                            imagenPerfil: response.data.imagenPerfil,
                            Fecha: data.fecgra,
                            Difusion: data.difusion,
                            Id: data.notA_Id,
                            Leido: data.leido,
                            destinatario: response2.data.nombrecompleto,
                          },
                        ]);
                      }
                    );
                  }
                );
              } else {
                obtenerUsuarioConImagen(data.remitenteUserName).then(
                  (response) => {
                    obtenerDatosUsuario(data.destinatarioUserName).then(
                      (response2) => {
                        setLista((anterior) => [
                          ...anterior,
                          {
                            Archivo: data.archivoUrl,
                            Texto: data.texto,
                            UserName: response.data.userName,
                            Token: response.data.token,
                            Email: response.data.email,
                            NOMBRECOMPLETO: response.data.nombrecompleto,
                            imagenPerfil: response.data.imagenPerfil,
                            Fecha: data.fecgra,
                            Difusion: data.difusion,
                            Id: data.notA_Id,
                            Leido: data.leido,
                            destinatario: response2.data.nombrecompleto,
                          },
                        ]);
                      }
                    );
                  }
                );
              }
              return lista;
            });
          }
        }
      );
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, [lista, sesionUsuario]);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
          p: 3,
          mb: 4,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              backdropFilter: 'blur(10px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SendIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
              Notas Enviadas
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'rgba(255,255,255,0.9)', mt: 0.5 }}
            >
              {sesionUsuario.usuario.nombrecompleto}
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <Box sx={{ mb: 3 }}>
          <LocalizationProvider locale={esLocale} utils={DateFnsUtils}>
            <DatePicker
              format="dd/MM/yyyy"
              label="Ver Notas por Fecha"
              value={selectedDate}
              onChange={handleDateChange}
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: 'outlined',
                  InputProps: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarTodayIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                      </InputAdornment>
                    ),
                  },
                },
              }}
            />
          </LocalizationProvider>
        </Box>

        <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
          Notas enviadas:
        </Typography>
        <List sx={{ mb: 2 }}>
          {lista.map((lista) => (
            <Box
              key={lista.Fecha}
              sx={{
                mb: 2,
                p: 2,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                backgroundColor: 'background.paper',
              }}
            >
              <ListItem sx={{ px: 0 }}>
                <ListItemAvatar>
                  <Avatar alt="Profile Picture" src={lista.imagenPerfil} />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      Nota de {lista.NOMBRECOMPLETO}
                    </Typography>
                  }
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body2"
                        color="textPrimary"
                        sx={{ display: 'block', my: 1 }}
                      >
                        {lista.Texto}
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                        <Typography variant="caption" color="textSecondary">
                          Enviado a {lista.destinatario}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          • A las {lista.Fecha.substr(11, 6)} hs
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          {lista.Leido !== null ? (
                            <>
                              <CheckCircleIcon sx={{ fontSize: 16, color: 'success.main' }} />
                              <Typography variant="caption" sx={{ color: 'success.main', fontWeight: 600 }}>
                                Leído
                              </Typography>
                            </>
                          ) : (
                            <>
                              <CancelIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                              <Typography variant="caption" color="textSecondary">
                                No leído
                              </Typography>
                            </>
                          )}
                        </Box>
                      </Box>
                    </React.Fragment>
                  }
                />
                {lista.Archivo === undefined ||
                lista.Archivo === 'undefined' ||
                lista.Archivo === null ? null : (
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<GetAppIcon />}
                    onClick={() => descargarArchivo(lista.Archivo)}
                    sx={{
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: 600,
                    }}
                  >
                    Descargar
                  </Button>
                )}
              </ListItem>
            </Box>
          ))}
        </List>
      </Paper>
    </Container>
  );
};
export default NotasEnviadas;
